import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ceaa71ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-md-5 py-md-5 project-overview-container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 col-lg-6 order-2 order-lg-1 overview-container p-5 p-lg-0 px-lg-5" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Project Overview", -1))
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { style: {"white-space":"pre-line"} }
const _hoisted_7 = {
  key: 0,
  class: "no-info"
}
const _hoisted_8 = { class: "col-12 col-lg-6 order-1 order-lg-2 px-0" }
const _hoisted_9 = { class: "d-none d-lg-flex player-container" }
const _hoisted_10 = {
  key: 0,
  class: "video-player",
  controls: "",
  preload: "metadata"
}
const _hoisted_11 = ["src", "type"]
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Your browser does not support the video tag. ")
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 2,
  class: "no-image"
}
const _hoisted_15 = { class: "d-flex d-lg-none player-container mobile" }
const _hoisted_16 = {
  key: 0,
  class: "video-player",
  controls: "",
  preload: "metadata"
}
const _hoisted_17 = ["src", "type"]
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Your browser does not support the video tag. ")
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 2,
  class: "no-image"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.portfolio.desc), 1),
          (!_ctx.portfolio.desc)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, " No information available. "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          (_ctx.video && _ctx.video.previewUrl)
            ? (_openBlock(), _createElementBlock("video", _hoisted_10, [
                _createElementVNode("source", {
                  src: _ctx.video.previewUrl,
                  type: _ctx.video.mimetype
                }, null, 8, _hoisted_11),
                _hoisted_12
              ]))
            : _createCommentVNode("", true),
          (_ctx.fallbackImage)
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: _ctx.fallbackImage,
                class: "fallback-image"
              }, null, 8, _hoisted_13))
            : _createCommentVNode("", true),
          (!_ctx.video && !_ctx.fallbackImage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, " Image Not Available. "))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_15, [
          (_ctx.video && _ctx.video.previewUrl)
            ? (_openBlock(), _createElementBlock("video", _hoisted_16, [
                _createElementVNode("source", {
                  src: _ctx.video.previewUrl,
                  type: _ctx.video.mimetype
                }, null, 8, _hoisted_17),
                _hoisted_18
              ]))
            : _createCommentVNode("", true),
          (_ctx.fallbackImage)
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: _ctx.fallbackImage,
                class: "fallback-image"
              }, null, 8, _hoisted_19))
            : _createCommentVNode("", true),
          (!_ctx.video && !_ctx.fallbackImage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, " Image Not Available. "))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}